import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 评比类型列表
  getEvaluateTypeList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATE_TYPE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学期考评统计
  getEvaluateSchoolTermStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATE_SCHOOL_TERM_STATISTICS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询教学周考评统计
  getEvaluateWeekStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATE_WEEK_STATISTICS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生考评统计
  getEvaluateStudentStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATE_STUDENT_STATISTICS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生评比记录列表（分页）
  getEvaluateEvaluateStudentList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_EVALUATE_STUDENT_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师考评学生
  getEvaluateTeacherEvaluateStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_EVALUATE_STUDENT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询年度教学周列表
  getYearTeachWeek(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SQUIRREL_GET_YEAR_TERM, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询教学周列表
  getEvaluateTeachWeekList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATE_TEACH_WEEK_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 导出学生德育考评记录为Excel（通过工作通知发送给操作人员）
  exportEvaluateStudentExcel(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_EVALUATE_EXPORT_STUDENT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询导出任务状态
  getEvaluateTask(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_TASK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置班牌名称
  setEvaluateDeviceBindName(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_DEVICE_NAME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询班牌详情
  getEvaluateDeviceDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_DEVICE_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班牌列表
  getEvaluateDeviceList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getBatchDeviceInfo(params) {
    return http.post(URL.API_BATCH_GET_DEVICE_DETAIL, params)
  },
  // 班牌列表
  getNewEvaluateDeviceList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_NEW_SQUIRREL_DEVICE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 批量查询设备在线状态和升级标识
  getEvaluateDeviceUpgradeFlag(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_UPGRADE_FLAG, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取版本号
  getEvaluateDeviceNewVersion(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_NEW_VERSION, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取rom版本号
  getEvaluateDeviceRomVersionList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_ROM_VERSION_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取apk版本号
  getEvaluateDeviceAppVersionList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_APP_VERSION_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取版本号列表
  getEvaluateDeviceNewVersionList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_NEW_VERSION_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取当前版本号详情
  getEvaluateDeviceVersionDetails(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_VERSION_DETAILS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 解绑设备
  getEvaluateDeviceUnbindBatch(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_DEVICE_UNBIND_BATCH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备版本升级
  getEvaluateDeviceUpgradeNew(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_DEVICE_UPGRADE_NEW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备批量升级
  getEvaluateDeviceUpgradeList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_DEVICE_UPGRADE_LIST_NEW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询app升级状态
  getEvaluateDeviceUpgradeStutus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_UPGRADE_STATUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 提交激活二维码
  evaluateActiveDeviceByQrcode(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SQUIRREL_DEVICE_QRCODE_UPDATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取设备网络状态
  getEvaluateDeviceNetwork(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_NETWORK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备批量解绑
  getEvaluateDeviceUnbind(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICE_UNBIND, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取钉钉版本的设备激活状态
  getEvaluateDeviceActiveStatusDing(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_DING_ACTIVE_STATUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取机构信息
  getEvaluateDeviceGetCorpInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_CORPINFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 创建并绑定机构
  getEvaluateDeviceCreateAndBindOrg(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_POST_CORP_BIND, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备网络状态
  getEvaluateDeviceNetStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DEVICES_NET_STATUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 重置沙盒状态，当沙盒变更处理超时时，要调些接口
  async addressResetStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_RESET, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取考评老师的考评类型列表
  getEvaluateListTeacherMoralEduEvaluationGroup(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_LIST_TEACHER_MORAL_EDU_EVALUATION_GROUP,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 导出德育报表为Excel
  moralExport(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_MORAL_EXPORT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取学生个人学期考评总计
  getMoralEduStudentTermEvaluationTotalStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_STUDENT_TERM_EVALUATION_TOTAL_STATISTICS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取学生个人周考评总计
  getMoralEduStudentWeekEvaluationTotalStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_STUDENT_WEEK_EVALUATION_TOTAL_SATTISTICS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询班级学生学期考评统计
  getListClassTermEvaluationStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_LIST_CLASS_TERM_EVALUATION_STATISTICS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询班级学生周考评统计
  getListClassWeekMoralEduStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_LIST_CLASS_WEEK_EVALUATION_STATISTICS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询部门学期考评统计
  getListDeptTermEvaluationStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_LIST_DEPT_TERM_EVALUATION_STATISTICS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询部门周考评统计
  getListDeptWeekEvaluationStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_LIST_DEPT_WEEK_EVALUATION_STATISTICS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 统计待审核学生评比记录数量
  getEvaluateCountWaitApprove(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_MORAL_COUNT_WAIT_APPROVE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生考评记录明细
  queryStudentMoralEduEvaluationDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_MORAL_QUERY_STUDENT_EVALUATION_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 修改学生评比记录状态
  evaluateUpdateStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(
          URL.API_POST_SQUIRREL_MORAL_STUDENT_EVALUATION_UPDATE_STATUS,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取学生德育评比申请记录
  getStudentSimpleEvaluationRecord(params) {
    return new Promise((resolve, reject) => {
      http
        .get(
          URL.API_GET_SQUIRREL_MORAL_GET_STUDENT_SIMPLE_EVALUATION_RECORD,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取学生德育评比申请记录
  getGradeList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_GRADE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取考评老师德育评比记录
  getListSimpleEvaluationRecord(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_MORAL_LIST_SIMPLE_EVALUATION_RECORD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取考评老师德育评比记录-我的考评
  getListEvaluationRecord(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_MORAL_LIST_EVALUATION_RECORD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取德育申请记录
  querySimpleEvaluationRecord(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_MORAL_QUERY_SIMPLE_EVALUATION_RECORD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师考评学生
  teacherEvaluationStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_POST_SQUIRREL_MORAL_TEACHER_EVALUATION_STUDENT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师批量考评学生
  teacherBatchEvaluationStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(
          URL.API_POST_SQUIRREL_MORAL_TEACHER_BATCH_EVALUATION_STUDENT,
          params
        )
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 人脸识别
  recognizeFace(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_POST_SQUIRREL_MORAL_RECOGNIZE_FACE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  recognizeAfterSchoolFace(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_POST_SCHOOL_RECOGNIZE_FACE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询评比项目
  listEvaluationProject(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATION_TYPE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师评比班级
  teacherEvaluationClass(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_POST_SQUIRREL_EVALUATION_TEACHER, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级周总分统计
  listClassWeekScoreEvaluationRecordStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATION_FITURE_STATISTICS_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 部门统计（支持查询校区下的年级统计、年级下的班级统计 适用于管理员角色）
  getDeptStatistics(params) {
    return http.get(URL.API_GET_DEPT_STATISTICS, params)
  },
  // 查询部门树（年级 -> 班级 -> 查询当天的该班级的班级评比记录列表）
  getDeptTreeByRole(params) {
    return http.get(URL.API_GET_DEPT_TREE_BY_ROLE, params)
  },
  // 部门统计（适用于值周老师、班主任角色）
  getDeptStatisticsByRole(params) {
    return http.get(URL.API_GET_DEPT_STATISTICS_BY_ROLE, params)
  },
  //  班级周统计与流水(周)
  listClassWeekStatisticsWithRecord(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SQUIRREL_EVALUATION_CLASS_WEEK_STATISTICS_FLOW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 导出统计报表（通过工作通知发送给操作人员）
  classrankExport(params) {
    return http.post(URL.API_CLASSRANK_EXPORT, params)
  },
  // 班级评比撤销当天记录
  classrankBackout(params) {
    return http.post(URL.API_CLASSRANK_BACKOUT, params)
  },
  // 创建学生家长单聊会话
  chatCreateS1G1Group(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_CHAT_CREATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查用户参于的的有聊天组
  chatQuery2pPeerUser(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_CHAT_QUERY_GROUP, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 消息撤回
  chatMessageCancel(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_CHAT_CANCEL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查用户聊天记录
  chatQueryMessageGroup(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_CHAT_QUERY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生家长1:1会话发消息
  chatMessageSend(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_CHAT_SEND, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 标记已读
  chatMessageMarkread(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_CHAT_MARKREAD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 统计校区班牌数量
  squirrelDeviceCountByCampus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_SQUIRREL_DEVICES, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 取消发布
  squirrelPublishCancelPublish(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSCARD_PUBLISH_CANCEL_PUBLISH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班牌部门子节点
  squirrelPublishGetSubNode(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_PUBLISH_GET_SUB_NODE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取一个完整班牌树 金典校区学段-年级-班牌，自定义校区a部门-b部门-xx部门-班级上一级部门-班牌
  squirrelGetClassPadDeptTree(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_GET_PAD_TREE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 进行发布
  squirrelPublishDoPublish(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSCARD_PUBLISH_DO_PUBLISH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取发布详情
  squirrelPublishGetPublishDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_PUBLISH_GET_PUBLISH_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班主任可展示的班牌列表
  squirrelPublishListAdviserClassPad(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_PUBLISH_ADVISER_CLASSPAD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班牌设备额外配置信息
  getDeviceExtraInfo(params) {
    return http.get(URL.API_H5_GET_DEVICE_EXTRA_INFO, params)
  },
  // 修改班牌设备额外配置信息
  updateDeviceExtraInfo(params) {
    return http.post(URL.API_H5_UPDATE_DEVICE_EXTRA_INFO, params)
  },
  // 获取内容发布记录(分页)
  squirrelPublishListPage(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_PUBLISH_LIST_PAGE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查看选中的班牌，按学段分类，展示班牌
  squirrelPublishListSelectedClassPad(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSCARD_PUBLISH_SELECTED_CLASSPAD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查看显示的班牌，按学段分类，展示班牌
  squirrelPublishListShowClassPad(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_PUBLISH_SHOW_CLASSPAD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索班牌列表
  squirrelPublishSearchClassPad(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_PUBLISH_SEARCH_CLASSPAD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班牌配置详情
  squirrelGetClassPadConfigDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_GET_CONFIG_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 判断选中的班牌是否被其他班牌设置使用
  squirrelJudgeClassPadHasUse(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_JUDGE_HAS_USE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班牌配置
  squirrelListClassPadConfig(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_GET_CONFIG_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 添加班牌配置
  squirrelSaveClassPadConfig(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSCARD_ADD_CONFIG, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑班牌配置
  squirrelUpdateClassPadConfig(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSCARD_UPDATE_CONFIG, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除班牌配置
  squirrelDeleteClassPadConfig(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASSCARD_DELETE_CONFIG, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 新留言查询
  squirrelMessageQueryNew(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_MESSAGE_QUERY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询设备模式详情
  squirrelDeviceModelDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_DEVICEMODEL_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备模式-获取所有校区以及校区下的班级数量
  squirrelDeviceModelCampusClassCount(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_DEVICEMODEL_CAMPUS_CLASS_COUNT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备模式-保存班牌绑定范围
  squirrelDeviceModelSave(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DEVICEMODEL_SAVE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生荣誉取消发布
  squirrelHonourCancelPublish(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_Honour_CANCEL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取学生荣誉绑定设备
  getStudentHonourDeviceList(params) {
    return http.get(URL.API_STUDENTHONOUR_DEVICE_LIST, params)
  },
  // 获取学生荣誉发布记录(分页)
  squirrelHonourList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_HONOUR_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生荣誉发布
  squirrelHonourPublish(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_HONOUR_PUBLISH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置设备名称
  squirrelSaveDeviceName(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_DEVICE_NAME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询年度学年学期
  getSchoolYearTermList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCHOOL_YEAR_TERM_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 升级学年
  getYearUpdate(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_YEAR_UPDATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 是否可升级学年
  getIsYearUpdate(params) {
    return http.get(URL.API_GET_IS_YEAR_UPDATE, params)
  },
  // 查询学年结束时间
  getYearEndDate(params) {
    return http.get(URL.API_GET_SCHOOL_YEAR_END_DATE, params)
  },
  // 查询当前学年学期
  getCurrentSchoolTerm(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCHOOL_TERM, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存或者更新学年学期
  saveSchoolTermSetting(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SVAE_SCHOOL_TERM, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取校区下亲情通话设置
  getFamilyCallSetting(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_SETTING, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存校区下亲情通话设置
  saveFamilyCallSetting(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_CALL_SETTING, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存校区下亲情通话设置
  checkFamilyCallUpgrade(params) {
    return http.get(URL.API_FAMILYCALL_IS_UPGRADE, params)
  },

  // 获取通话设备管理 设备列表
  getFamilyCallDeviceList(params) {
    return http.post(URL.API_GET_DEVICE_LIST, params)
  },
  // 保存校区下设备通话设置
  saveFamilyCallDeviceSetting(params) {
    return http.post(URL.API_SAVE_CALL_DEVICE_SETTING, params)
  },
  // 年级统计（教学周）
  getFamilyCallGradeStat(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_GRADE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级统计（教学周）
  getFamilyCallClassStat(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_CLASS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级通话详情（教学周）
  getFamilyCallClassDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_CLASS_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级统计（教学周）
  getFamilyCallStudentDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_STUDENT_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 个人通话历史记录明细
  getFamilyCallStudentRecord(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_STUDENT_RECORD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某个学生是否存在亲情通话记录,按时间排序从1号开始一直到当前日 1：存在 0：不存在
  getFamilyCallStudentCalendar(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CALL_STUDENT_CALENDAR, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getFamilyNaturalWeek(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_NATURAL_WEEK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 校区班级光盘记录统计
  getStatCampusClass(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEARPLATE_GET_CAMPUS_CLASS_STA, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 校区年级光盘记录统计
  getStatCampusGrade(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEARPLATE_GET_CAMPUS_STA, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级光盘明细 记录统计
  getStatClassDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEARPLATE_GET_CLASS_STA, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 年级班级光盘记录统计
  getStatGradeClass(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEARPLATE_GET_GRADE_STA, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 个人光盘记录统计
  getStatUserDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEARPLATE_GET_USER_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getStatUserSummary(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEARPLATE_GET_USER_STA, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询亲情通话设置开关
  getFamilyCallSettingSwitch(params) {
    return http.get(URL.API_GET_SETTING_SWITCH, params)
  },
  // 查询未设置班主任的班级列表
  getFamilyCallNoAdviserClass(params) {
    return http.get(URL.API_GET_SETTING_NO_ADVISER_CLASS, params)
  },
  getClassPadTemplateList(params) {
    return http.get(URL.API_CLASSCARD_TEMPLATE_LIST, params)
  },
  // H5端扫码，将机构更新到二维码中
  updateDeviceQrcode(params) {
    return http.post(URL.API_DEVICE_UPDATE_QRCODE, params)
  },
  // H5端获取激活的状态，轮询操作
  getEvaluateDeviceActiveStatus(params) {
    return http.post(URL.API_DEVICE_UPDATE_ACTIVE_STATUS, params)
  },
  /**
   * 获取设备后台离线密码
   */
  apiDeviceOfflinePassword(postData) {
    return http.post(URL.API_DEVICE_OFFLINE_PASSWORD, postData)
  },
  getEvaluationRecord(params) {
    return http.post(URL.API_GET_EVALUATION_LIST, params)
  },
  deleteEvaluationRecord(params) {
    return http.get(URL.API_DELETE_EVALUATION_LIST, params)
  },
  // 班牌绑定自定义模式
  postBindCustomMode(params) {
    return http.post(URL.API_CLASSCARD_DEVICE_BIND_CUSTOMMODE, params)
  },
  // 判断这个机构是否支持班牌自定义模式
  getSupportCustomMode(params) {
    return http.get(URL.API_CLASSCARD_DEVICE_SUPPORT_CUSTOMMODE, params)
  },
  // 机构是否可在班牌管理开门权限组
  canConfigOpenDoorPermissionGroup(params) {
    return http.get(
      URL.API_SCHOOL_H5_DEVICE_CAN_CONFIG_OPEN_DOOR_PERMISSION_GROUP,
      params
    )
  },
  // 创建开门权限组
  createOpenDoorPermissionGroup(params) {
    return http.post(
      URL.API_SCHOOL_H5_DEVICE_CREATE_OPEN_DOOR_PERMISSION_GROUP,
      params
    )
  },
  // 查询权限组下的设备sn
  getGroupDeviceIds(params) {
    return http.get(URL.API_SCHOOL_H5_DEVICE_GET_GROUP_DEVICE_SN, params)
  },
  // 获取群组范围内部门/人员名称
  getGroupRange(params) {
    return http.get(URL.API_SCHOOL_H5_DEVICE_GET_RANGE_NAME, params)
  },
  // 机构下是否有门禁设备
  getHasDevice(params) {
    return http.get(URL.API_SCHOOL_H5_DEVICE_HAS_DEVICE, params)
  },
  // 查询开门权限组列表
  listOpenDoorPermissionGroup(params) {
    return http.get(
      URL.API_SCHOOL_H5_DEVICE_LIST_OPEN_DOOR_PERMISSION_GROUP,
      params
    )
  },
  // 移除开门权限
  removeOpenDoorPermissionGroup(params) {
    return http.get(
      URL.API_SCHOOL_H5_DEVICE_REMOVE_OPEN_DOOR_PERMISSION_GROUP,
      params
    )
  },
  // 更新开门权限
  updateOpenDoorPermissionGroup(params) {
    return http.post(
      URL.API_SCHOOL_H5_DEVICE_UPDATE_OPEN_DOOR_PERMISSION_GROUP,
      params
    )
  },
  // 根据机构查询标签
  getListTags(params) {
    return http.get(URL.API_SCHOOL_H5_DEVICE_LIST_TAGS, params)
  },
  // 批量休眠
  betchUpdateSleepStatus(params) {
    return http.post(URL.API_BETCH_UPDATE_SLEEP, params)
  },
  // 是否显示休眠入口
  getIsGrayOrg(params) {
    return http.get(URL.API_COMMON_IS_GRAYORG, params)
  },

  // 是否展示 班牌考场模式 栏目
  getExamModeOpen(params) {
    return http.post(URL.API_H5_GET_SHOW_EXAM, params)
  },
  // 获取 考场模式配置
  getExamModeConfig(params) {
    return http.post(URL.API_H5_GET_EXAM_CONFIG, params)
  },
  // 变更 考场模式配置
  saveExamModeConfig(params) {
    return http.post(URL.API_H5_SAVE_EXAM_CONFIG, params)
  }
}
